import React from 'react';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';

const ContactsPage = () => {
  const contacts = [
    {
      icon: <FiMapPin />,
      title: 'Адрес',
      content: 'г. Новосибирск, ул. Николаева, д. 12',
    },
    {
      icon: <FiPhone />,
      title: 'Телефон',
      content: '+7 (996) 550-86-63',
      detail: 'Пн-Пт, 9:00-18:00'
    },
    {
      icon: <FiMail />,
      title: 'Email',
      content: 'syroletka@gmail.com',
    }
  ];

  return (
    <div className="contacts-page">
      {/* Animated Background */}
      <div className="contacts-bg">
        <div className="bg-pattern"></div>
        <div className="floating-dots">
          {[...Array(20)].map((_, i) => (
            <div 
              key={i}
              className="dot"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`
              }}
            />
          ))}
        </div>
      </div>

      {/* Hero Section */}
      <section className="contacts-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Свяжитесь с нами</h1>
            <p className="hero-description">
              Есть вопросы или предложения? Мы всегда готовы к диалогу и сотрудничеству. 
              Напишите нам или позвоните — мы поможем реализовать ваши идеи.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Cards */}
      <section className="contact-cards-section">
        <div className="container">
          <div className="cards-grid">
            {contacts.map((contact, index) => (
              <div 
                key={index} 
                className="contact-card fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="card-icon">
                  {contact.icon}
                </div>
                <div className="card-content">
                  <h3 className="card-title">{contact.title}</h3>
                  <p className="card-main">{contact.content}</p>
                  <p className="card-detail">{contact.detail}</p>
                </div>
                <div className="card-glow"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content - без формы обратной связи */}
      <section className="main-content-section">
        <div className="container">
          <div className="content-grid">
            {/* Info Section - расширенный */}
            <div className="info-section full-width">
              {/* Яндекс Карта - iframe версия */}
              <div className="map-card card">
                <div className="map-header">
                  <h3>Схема проезда</h3>
                  <span className="map-badge">Яндекс.Карты</span>
                </div>
                <div className="yandex-map-container">
                  <iframe 
                    src="https://yandex.ru/map-widget/v1/?ll=82.9204%2C55.0304&mode=search&text=Новосибирск%2C%20ул.%20Николаева%2C%2012&z=17"
                    width="100%" 
                    height="100%" 
                    frameBorder="0"
                    title="Яндекс Карта"
                    allowFullScreen
                    style={{border: 'none'}}
                  />
                </div>
                <div className="map-address">
                  <FiMapPin className="address-icon" />
                  <span>г. Новосибирск, ул. Николаева, д. 12</span>
                </div>
              </div>

              {/* Support Info */}
              <div className="support-card card">
                <div className="support-header">
                  <h3>О поддержке проекта</h3>
                  <div className="support-badge">Грант 2025</div>
                </div>
                <div className="support-content">
                  <p>
                    Проект реализован при поддержке Фонда содействия инновациям в рамках программы 
                    «Студенческий стартап» мероприятия «Платформа университетского 
                    технологического предпринимательства» федерального проекта «Технологии»
                  </p>
                  <div className="support-links">
                    <a 
                      href="https://fasie.ru" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="support-link"
                    >
                      Подробнее о программе →
                    </a>
                  </div>
                </div>
              </div>

              {/* FAQ */}
              <div className="faq-card card">
                <h3>Частые вопросы</h3>
                <div className="faq-list">
                  <div className="faq-item">
                    <div className="faq-question">Как быстро вы отвечаете?</div>
                    <div className="faq-answer">В течение 24 часов в рабочие дни.</div>
                  </div>
                  
                  <div className="faq-item">
                    <div className="faq-question">Есть ли партнерская программа?</div>
                    <div className="faq-answer">Да, обсуждается индивидуально.</div>
                  </div>
                  
                  <div className="faq-item">
                    <div className="faq-question">Работаете ли с НИИ?</div>
                    <div className="faq-answer">Да, сотрудничаем с СибНИИ сыроделия ФГБНУ ФАНЦА (Барнаул).</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .contacts-page {
          position: relative;
          min-height: 100vh;
        }

        /* Background */
        .contacts-bg {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
          z-index: -1;
        }

        .bg-pattern {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: 
            radial-gradient(circle at 20% 30%, rgba(59, 130, 246, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 80% 70%, rgba(139, 92, 246, 0.05) 0%, transparent 50%);
        }

        .floating-dots {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }

        .dot {
          position: absolute;
          width: 4px;
          height: 4px;
          background: var(--primary);
          border-radius: 50%;
          opacity: 0.3;
          animation: floatUp 10s infinite linear;
        }

        @keyframes floatUp {
          0% {
            transform: translateY(100vh) scale(1);
            opacity: 0;
          }
          10% {
            opacity: 0.3;
          }
          90% {
            opacity: 0.3;
          }
          100% {
            transform: translateY(-100px) scale(0.5);
            opacity: 0;
          }
        }

        /* Hero Section */
        .contacts-hero {
          padding: 100px 0 60px;
          text-align: center;
        }

        .hero-content {
          max-width: 600px;
          margin: 0 auto;
        }

        .hero-title {
          font-size: 3.5rem;
          margin-bottom: 20px;
          background: linear-gradient(135deg, #fff, var(--primary));
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .hero-description {
          font-size: 1.125rem;
          color: #CBD5E1;
          line-height: 1.6;
        }

        /* Contact Cards */
        .contact-cards-section {
          padding: 40px 0;
        }

        .cards-grid {
          display: grid;
          gap: 24px;
          grid-template-columns: repeat(3, 1fr);
        }

        .contact-card {
          background: var(--bg-card);
          backdrop-filter: blur(10px);
          border: 1px solid var(--border-color);
          border-radius: var(--radius-lg);
          padding: 30px;
          display: flex;
          align-items: center;
          gap: 20px;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          opacity: 0;
          animation: fadeIn 0.6s ease-out forwards;
        }

        .contact-card:hover {
          transform: translateY(-5px);
          border-color: var(--primary);
          box-shadow: var(--shadow-glow);
        }

        .card-glow {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: var(--gradient-primary);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .contact-card:hover .card-glow {
          opacity: 1;
        }

        .card-icon {
          width: 60px;
          height: 60px;
          background: rgba(59, 130, 246, 0.1);
          border-radius: var(--radius-md);
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--primary);
          font-size: 1.5rem;
          flex-shrink: 0;
        }

        .card-content {
          flex: 1;
        }

        .card-title {
          font-size: 1.25rem;
          color: #fff;
          margin-bottom: 5px;
        }

        .card-main {
          font-size: 1.125rem;
          font-weight: 500;
          color: #fff;
          margin-bottom: 5px;
        }

        .card-detail {
          font-size: 0.875rem;
          color: #CBD5E1;
          margin: 0;
        }

        /* Main Content */
        .main-content-section {
          padding: 60px 0 100px;
        }

        .content-grid {
          display: grid;
          gap: 40px;
        }

        .info-section.full-width {
          width: 100%;
        }

        /* Map Card - увеличенная высота */
        .map-card {
          background: var(--bg-card);
          backdrop-filter: blur(10px);
          border: 1px solid var(--border-color);
          border-radius: var(--radius-lg);
          padding: 24px;
          transition: all 0.3s ease;
          margin-bottom: 24px;
        }

        .map-card:hover {
          transform: translateY(-5px);
          border-color: var(--primary);
        }

        .map-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .map-header h3 {
          margin: 0;
          color: #fff;
          font-size: 1.3rem;
        }

        .map-badge {
          padding: 6px 14px;
          background: rgba(59, 130, 246, 0.15);
          color: var(--primary);
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 500;
          border: 1px solid rgba(59, 130, 246, 0.3);
        }

        /* Яндекс Карта контейнер - увеличенная высота */
        .yandex-map-container {
          width: 100%;
          height: 450px;
          background: rgba(0, 0, 0, 0.2);
          border-radius: var(--radius-md);
          overflow: hidden;
          margin-bottom: 16px;
          border: 1px solid var(--border-color);
        }

        .yandex-map-container iframe {
          width: 100%;
          height: 100%;
          border: none;
        }

        /* Адрес под картой */
        .map-address {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px 16px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: var(--radius-md);
          border: 1px solid var(--border-color);
          color: #CBD5E1;
          font-size: 0.95rem;
        }

        .address-icon {
          color: var(--primary);
          font-size: 1.2rem;
          flex-shrink: 0;
        }

        /* Support Card */
        .support-card,
        .faq-card {
          background: var(--bg-card);
          backdrop-filter: blur(10px);
          border: 1px solid var(--border-color);
          border-radius: var(--radius-lg);
          padding: 24px;
          transition: all 0.3s ease;
          margin-bottom: 24px;
        }

        .support-card:hover,
        .faq-card:hover {
          transform: translateY(-5px);
          border-color: var(--primary);
        }

        .support-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .support-header h3 {
          margin: 0;
          color: #fff;
        }

        .support-badge {
          padding: 4px 12px;
          background: rgba(139, 92, 246, 0.1);
          color: #8B5CF6;
          border-radius: 20px;
          font-size: 0.75rem;
          font-weight: 500;
        }

        .support-content p {
          color: #CBD5E1;
          font-size: 0.875rem;
          line-height: 1.5;
          margin-bottom: 16px;
        }

        .support-links {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
        }

        .support-link {
          color: var(--primary);
          font-size: 0.875rem;
          text-decoration: none;
          transition: color 0.3s ease, transform 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }

        .support-link:hover {
          color: #60A5FA;
          transform: translateX(4px);
        }

        .faq-card h3 {
          margin: 0 0 20px 0;
          color: #fff;
        }

        .faq-list {
          display: grid;
          gap: 16px;
        }

        .faq-item {
          border-bottom: 1px solid var(--border-color);
          padding-bottom: 16px;
        }

        .faq-item:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .faq-question {
          font-weight: 500;
          color: #fff;
          margin-bottom: 8px;
        }

        .faq-answer {
          font-size: 0.875rem;
          color: #CBD5E1;
          line-height: 1.5;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .cards-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 16px;
          }

          .hero-title {
            font-size: 3rem;
          }

          .contact-card {
            padding: 24px;
          }

          .card-icon {
            width: 50px;
            height: 50px;
            font-size: 1.2rem;
          }

          .yandex-map-container {
            height: 400px;
          }
        }

        @media (max-width: 768px) {
          .contacts-hero {
            padding: 80px 0 40px;
          }

          .hero-title {
            font-size: 2.5rem;
          }

          .hero-description {
            font-size: 1rem;
            padding: 0 16px;
          }

          .cards-grid {
            grid-template-columns: 1fr;
            gap: 16px;
          }

          .contact-card {
            flex-direction: column;
            text-align: center;
            padding: 24px;
          }

          .card-icon {
            width: 60px;
            height: 60px;
            margin-bottom: 16px;
          }

          .card-main {
            font-size: 1rem;
          }

          .card-detail {
            font-size: 0.8rem;
          }

          .support-header,
          .map-header {
            flex-direction: column;
            gap: 8px;
            align-items: flex-start;
          }

          .support-badge,
          .map-badge {
            align-self: flex-start;
          }

          .yandex-map-container {
            height: 350px;
          }

          .support-links {
            flex-direction: column;
            gap: 8px;
          }
        }

        @media (max-width: 480px) {
          .container {
            padding-left: 12px;
            padding-right: 12px;
          }

          .hero-title {
            font-size: 2rem;
          }

          .hero-description {
            font-size: 0.9rem;
          }

          .contact-card {
            padding: 20px;
          }

          .card-icon {
            width: 50px;
            height: 50px;
            font-size: 1rem;
          }

          .card-title {
            font-size: 1rem;
          }

          .card-main {
            font-size: 0.9rem;
          }

          .card-detail {
            font-size: 0.75rem;
          }

          .map-card,
          .support-card,
          .faq-card {
            padding: 20px;
          }

          .yandex-map-container {
            height: 300px;
          }

          .map-address {
            font-size: 0.85rem;
            padding: 10px 12px;
          }

          .support-content p,
          .faq-question,
          .faq-answer {
            font-size: 0.8rem;
          }

          .support-link {
            font-size: 0.75rem;
          }
        }

        /* Планшетная версия (768px - 1024px) */
        @media (min-width: 768px) and (max-width: 1024px) {
          .container {
            max-width: 900px;
            padding-left: 24px;
            padding-right: 24px;
          }

          .cards-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 16px;
          }

          .contact-card {
            padding: 20px;
          }

          .card-icon {
            width: 50px;
            height: 50px;
            font-size: 1.2rem;
          }

          .card-title {
            font-size: 1rem;
          }

          .card-main {
            font-size: 0.9rem;
          }

          .yandex-map-container {
            height: 400px;
          }

          .map-address {
            font-size: 0.9rem;
          }
        }

        @keyframes fadeIn {
          to {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default ContactsPage;
